(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produktfinder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function el(tag, props, kids) {
      var node = document.createElement(tag);
      Object.keys(props || {}).forEach(function (k) {
        if (k === 'text') node.textContent = props[k];
        else if (props[k] !== null && props[k] !== undefined) node.setAttribute(k, props[k]);
      });
      (kids || []).forEach(function (kid) {
        if (kid) node.appendChild(typeof kid === 'string' ? document.createTextNode(kid) : kid);
      });
      return node;
    }

    function init(root) {
      if (root.getAttribute('data-jpf-ready')) return;
      var dataEl = root.querySelector('script[data-jpf-data]');
      var stage = root.querySelector('[data-jpf-stage]');
      if (!dataEl || !stage) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var qs = data.questions || [];
      var products = data.products || {};
      if (!qs.length) return;
      root.setAttribute('data-jpf-ready', '1');

      var texts = root.querySelector('[data-jpf-texts]');
      var T = {
        resultHeading: texts.getAttribute('data-result-heading') || 'Ihre Auswahl',
        resultIntro: texts.getAttribute('data-result-intro') || '',
        disclaimer: texts.getAttribute('data-disclaimer') || '',
        emailHeading: texts.getAttribute('data-email-heading') || '',
        emailText: texts.getAttribute('data-email-text') || '',
        emailButton: texts.getAttribute('data-email-button') || 'Absenden',
        consentLabel: texts.getAttribute('data-consent-label') || '',
        newsletterLabel: texts.getAttribute('data-newsletter-label') || '',
        privacyUrl: texts.getAttribute('data-privacy-url') || '',
        emailSuccess: texts.getAttribute('data-email-success') || 'Danke!'
      };
      var maxResults = parseInt(root.getAttribute('data-max-results'), 10) || 3;

      // Anonyme Speicherung (Antworten + empfohlene Produkte, keine E-Mail) über einen
      // eigenen Relay-Endpunkt, der sie als Shopify-Metaobjekt ablegt.
      var relayUrl = root.getAttribute('data-relay-url') || '';
      var relayToken = root.getAttribute('data-relay-token') || '';
      var logOn = !!relayUrl && root.getAttribute('data-log') === 'true';

      // E-Mail + Produktempfehlung direkt an Klaviyo (Client-API, öffentlicher Key).
      // Es werden nie Quiz-Antworten an Klaviyo übertragen.
      var klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
      var klaviyoMetric = root.getAttribute('data-klaviyo-metric') || 'Completed Product Quiz';
      var klaviyoListId = root.getAttribute('data-klaviyo-list') || '';
      var emailOn = !!klaviyoKey && root.getAttribute('data-email') === 'true' && !!T.consentLabel;

      function newId() {
        try {
          var a = new Uint8Array(8);
          window.crypto.getRandomValues(a);
          return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        } catch (e) {
          return String(Date.now()) + String(Math.floor(Math.random() * 1e6));
        }
      }

      function sendToRelay(payload) {
        payload.v = 1;
        payload.source = 'jorinde-produktfinder';
        payload.token = relayToken;
        payload.page = window.location.pathname;
        return fetch(relayUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload),
          keepalive: true
        });
      }

      function klaviyoFetch(path, body) {
        return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(klaviyoKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
          body: JSON.stringify(body)
        });
      }

      function sendToKlaviyo(email, recommended, resultId, subscribeNewsletter) {
        var properties = {
          ResultID: resultId,
          Page: window.location.pathname,
          RecommendedProducts: recommended.map(function (p) {
            return { Name: p.title, URL: p.url, ImageURL: p.image };
          })
        };
        var eventPromise = klaviyoFetch('events', {
          data: {
            type: 'event',
            attributes: {
              properties: properties,
              unique_id: 'jpf-' + resultId,
              metric: { data: { type: 'metric', attributes: { name: klaviyoMetric } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        });
        if (!subscribeNewsletter || !klaviyoListId) return eventPromise;
        return eventPromise.then(function () {
          return klaviyoFetch('subscriptions', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Produktfinder',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: klaviyoListId } } }
            }
          });
        });
      }

      // Fragen mit Hinweis (z. B. Medikamente, Schwangerschaft) oder "nie speichern" werden nie übertragen.
      function storableAnswers() {
        var out = [];
        qs.forEach(function (q, qi) {
          if (q.noStore || String(q.hintAnswers || '').trim()) return;
          out.push({
            q: q.question,
            a: sel[qi].map(function (ai) { return q.answers[ai] ? q.answers[ai].label : ''; }).filter(Boolean)
          });
        });
        return out;
      }

      function emailBox(resultId, recommended, onDone) {
        var form = el('form', { 'class': 'jpf__mail' });
        var inputId = 'jpf-mail-' + resultId;
        var input = el('input', { 'class': 'jpf__input', type: 'email', id: inputId, name: 'email', required: '', autocomplete: 'email', inputmode: 'email', maxlength: '254' });
        var hp = el('input', { type: 'text', name: 'website', tabindex: '-1', autocomplete: 'off' });
        var consent = el('input', { type: 'checkbox', name: 'consent', required: '' });
        var consentText = el('span', { text: T.consentLabel + ' ' });
        if (T.privacyUrl) consentText.appendChild(el('a', { href: T.privacyUrl, target: '_blank', rel: 'noopener', text: 'Datenschutzerklärung' }));
        var news = (T.newsletterLabel && klaviyoListId) ? el('input', { type: 'checkbox', name: 'newsletter' }) : null;
        var status = el('p', { 'class': 'jpf__small', role: 'status' });
        var submit = el('button', { type: 'submit', 'class': 'jpf__btn jpf__btn--primary', text: T.emailButton });

        if (T.emailHeading) form.appendChild(el('h3', { 'class': 'jpf__name', text: T.emailHeading }));
        if (T.emailText) form.appendChild(el('p', { text: T.emailText }));
        form.appendChild(el('label', { 'for': inputId, 'class': 'visually-hidden', text: 'E-Mail-Adresse' }));
        form.appendChild(input);
        form.appendChild(el('div', { 'class': 'visually-hidden', 'aria-hidden': 'true' }, [hp]));
        form.appendChild(el('label', { 'class': 'jpf__check' }, [consent, consentText]));
        if (news) form.appendChild(el('label', { 'class': 'jpf__check' }, [news, el('span', { text: T.newsletterLabel })]));
        form.appendChild(el('div', { 'class': 'jpf__nav' }, [submit]));
        form.appendChild(status);

        function done() {
          form.innerHTML = '';
          form.appendChild(el('p', { role: 'status', text: T.emailSuccess }));
          setTimeout(onDone, 900);
        }
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (hp.value) { done(); return; }
          submit.disabled = true;
          status.textContent = '';
          sendToKlaviyo(input.value.trim(), recommended, resultId, !!(news && news.checked))
            .then(function (r) { if (!r.ok && r.status !== 202) throw new Error('rejected'); done(); })
            .catch(function () {
              submit.disabled = false;
              status.textContent = 'Das hat nicht geklappt. Bitte versuchen Sie es später noch einmal.';
            });
        });
        return form;
      }

      var live = root.querySelector('[data-jpf-live]');
      var introHTML = stage.innerHTML;
      var sel = qs.map(function () { return []; });

      function announce(msg) { if (live) live.textContent = msg; }
      function show(node, focusSel, wide) {
        root.classList.toggle('jpf--wide', !!wide);
        stage.innerHTML = '';
        stage.appendChild(node);
        var f = focusSel && node.querySelector(focusSel);
        if (f) f.focus();
        stage.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      function hintIndexes(q) {
        return String(q.hintAnswers || '').split(',').map(function (s) { return parseInt(s, 10) - 1; }).filter(function (n) { return n >= 0; });
      }

      function renderQuestion(i) {
        var q = qs[i];
        var wrap = el('div', { 'class': 'jpf__q' });
        wrap.appendChild(el('p', { 'class': 'jpf__meta', text: 'Frage ' + (i + 1) + ' von ' + qs.length }));
        var bar = el('div', { 'class': 'jpf__bar', 'aria-hidden': 'true' });
        qs.forEach(function (_, n) { bar.appendChild(el('div', { 'class': 'jpf__seg' + (n <= i ? ' is-done' : '') })); });
        wrap.appendChild(bar);

        var fs = el('fieldset', { 'class': 'jpf__fieldset' });
        fs.appendChild(el('legend', { 'class': 'jpf__legend', tabindex: '-1', text: q.question }));
        if (q.multiple) fs.appendChild(el('p', { 'class': 'jpf__hintline', text: 'Mehrere Antworten möglich.' }));

        var opts = el('div', { 'class': 'jpf__opts' });
        var next;
        function refresh() {
          opts.querySelectorAll('.jpf__opt').forEach(function (lab) {
            lab.classList.toggle('is-checked', lab.querySelector('input').checked);
          });
          next.disabled = !q.optional && sel[i].length === 0;
          next.textContent = i === qs.length - 1 ? 'Ergebnis anzeigen' : (q.optional && sel[i].length === 0 ? 'Überspringen' : 'Weiter');
        }
        q.answers.forEach(function (a, ai) {
          var input = el('input', { type: q.multiple ? 'checkbox' : 'radio', name: 'jpf-q' + i, value: String(ai) });
          if (sel[i].indexOf(ai) > -1) input.checked = true;
          input.addEventListener('change', function () {
            if (q.multiple) {
              sel[i] = Array.prototype.map.call(opts.querySelectorAll('input:checked'), function (n) { return parseInt(n.value, 10); });
            } else {
              sel[i] = [ai];
            }
            refresh();
          });
          opts.appendChild(el('label', { 'class': 'jpf__opt' }, [input, el('span', { text: a.label })]));
        });
        fs.appendChild(opts);
        wrap.appendChild(fs);

        var nav = el('div', { 'class': 'jpf__nav' });
        var back = el('button', { type: 'button', 'class': 'jpf__btn', 'data-jpf-back': '', text: 'Zurück' });
        next = el('button', { type: 'button', 'class': 'jpf__btn jpf__btn--primary', 'data-jpf-next': '' });
        nav.appendChild(back);
        nav.appendChild(next);
        wrap.appendChild(nav);
        refresh();
        show(wrap, '.jpf__legend');
        announce('Frage ' + (i + 1) + ' von ' + qs.length);
        wrap.setAttribute('data-index', String(i));
      }

      function compute() {
        var scores = {};
        qs.forEach(function (q, qi) {
          sel[qi].forEach(function (ai) {
            var a = q.answers[ai];
            if (!a) return;
            a.products.forEach(function (h) {
              if (!products[h]) return;
              if (!scores[h]) scores[h] = { handle: h, score: 0, why: [], order: Object.keys(scores).length };
              scores[h].score += 1;
              if (scores[h].why.indexOf(a.label) === -1) scores[h].why.push(a.label);
            });
          });
        });
        return Object.keys(scores).map(function (h) { return scores[h]; })
          .filter(function (r) { return products[r.handle].available; })
          .sort(function (a, b) { return b.score - a.score || a.order - b.order; })
          .slice(0, maxResults);
      }

      function addToCart(items, btn) {
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Wird hinzugefügt …';
        fetch(root.getAttribute('data-cart-add-url'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        }).then(function () {
          window.location.href = root.getAttribute('data-cart-url');
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = 'Hat nicht geklappt. Nochmal versuchen';
          setTimeout(function () { btn.textContent = label; }, 3000);
        });
      }

      function renderEmailGate(resultId, results, recommendedForEmail) {
        var wrap = el('div', { 'class': 'jpf__results' });
        wrap.appendChild(el('h2', { 'class': 'jpf__title', tabindex: '-1', text: T.resultHeading }));
        if (T.resultIntro) wrap.appendChild(el('p', { 'class': 'jpf__lead', text: T.resultIntro }));

        wrap.appendChild(emailBox(resultId, recommendedForEmail, function () {
          renderProductResults(results, true);
        }));

        var skipNav = el('div', { 'class': 'jpf__nav', style: 'margin-top:4px' });
        var skip = el('button', { type: 'button', 'class': 'jpf__btn jpf__btn--ghost', text: 'Ohne E-Mail weiter zu den Empfehlungen' });
        skip.addEventListener('click', function () { renderProductResults(results, false); });
        skipNav.appendChild(skip);
        wrap.appendChild(skipNav);

        show(wrap, '.jpf__title');
        announce('Noch ein Schritt: E-Mail-Angebot');
      }

      function renderProductResults(results, afterEmailSubmit) {
        var wrap = el('div', { 'class': 'jpf__results' });
        wrap.appendChild(el('h2', { 'class': 'jpf__title', tabindex: '-1', text: T.resultHeading }));

        if (!results.length) {
          wrap.appendChild(el('p', { 'class': 'jpf__lead', text: root.getAttribute('data-empty-text') || '' }));
          wrap.appendChild(el('a', { 'class': 'jpf__btn jpf__btn--primary', href: root.getAttribute('data-fallback-url') || '/', text: 'Alle Produkte ansehen' }));
        } else {
          if (afterEmailSubmit && T.emailSuccess) wrap.appendChild(el('p', { 'class': 'jpf__lead', text: T.emailSuccess }));
          else if (T.resultIntro) wrap.appendChild(el('p', { 'class': 'jpf__lead', text: T.resultIntro }));

          var notes = [];
          qs.forEach(function (q, qi) {
            if (!q.hint) return;
            var hit = hintIndexes(q).some(function (n) { return sel[qi].indexOf(n) > -1; });
            if (hit && notes.indexOf(q.hint) === -1) notes.push(q.hint);
          });
          notes.forEach(function (n) { wrap.appendChild(el('p', { 'class': 'jpf__note', role: 'note', text: n })); });

          var cards = el('div', { 'class': 'jpf__cards' });
          results.forEach(function (r) {
            var p = products[r.handle];
            var card = el('div', { 'class': 'jpf__card' });
            if (p.image) card.appendChild(el('img', { 'class': 'jpf__img', src: p.image, alt: p.title, loading: 'lazy', width: '640', height: '640' }));
            card.appendChild(el('h3', { 'class': 'jpf__name' }, [el('a', { href: p.url, text: p.title })]));
            card.appendChild(el('p', { 'class': 'jpf__price', text: p.price }));
            card.appendChild(el('p', { 'class': 'jpf__why', text: 'Passt zu Ihren Antworten: ' + r.why.slice(0, 3).join(', ') }));
            var actions = el('div', { 'class': 'jpf__card-actions' });
            var add = el('button', { type: 'button', 'class': 'jpf__btn jpf__btn--primary', text: 'In den Warenkorb' });
            add.addEventListener('click', function () { addToCart([{ id: p.variantId, quantity: 1 }], add); });
            actions.appendChild(add);
            actions.appendChild(el('a', { 'class': 'jpf__link', href: p.url, text: 'Produkt ansehen' }));
            card.appendChild(actions);
            cards.appendChild(card);
          });
          wrap.appendChild(cards);

          if (results.length > 1) {
            var all = el('button', { type: 'button', 'class': 'jpf__btn', text: 'Alle ' + results.length + ' in den Warenkorb' });
            all.addEventListener('click', function () {
              addToCart(results.map(function (r) { return { id: products[r.handle].variantId, quantity: 1 }; }), all);
            });
            wrap.appendChild(el('div', { 'class': 'jpf__nav' }, [all]));
          }
        }

        wrap.appendChild(el('div', { 'class': 'jpf__nav', style: 'margin-top:16px' }, [
          el('button', { type: 'button', 'class': 'jpf__btn jpf__btn--ghost', 'data-jpf-restart': '', text: 'Produktfinder neu starten' })
        ]));
        if (T.disclaimer) wrap.appendChild(el('p', { 'class': 'jpf__small jpf__disclaimer', text: T.disclaimer }));
        show(wrap, '.jpf__title', true);
        announce(results.length ? results.length + ' Empfehlungen angezeigt' : 'Keine eindeutige Empfehlung');
      }

      // Fasst den Quiz-Abschluss zusammen: läuft genau einmal, unabhängig davon, ob
      // danach die E-Mail-Abfrage oder direkt die Produktempfehlungen angezeigt werden.
      function finish() {
        var results = compute();
        var resultId = newId();
        var recommendedForEmail = results.map(function (r) { return products[r.handle]; });

        // Anonyme Speicherung: nur die empfohlenen Produkte und speicherbaren Antworten,
        // nie eine E-Mail-Adresse (die geht separat und nur bei Einwilligung an Klaviyo).
        if (logOn) {
          try {
            sendToRelay({
              type: 'result',
              resultId: resultId,
              answers: storableAnswers(),
              productIds: results.map(function (r) { return 'gid://shopify/Product/' + products[r.handle].id; })
            }).catch(function () {});
          } catch (e) {}
        }
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'produktfinder_complete', produktfinder_results: results.map(function (r) { return r.handle; }).join(',') });
        } catch (e) {}
        root.dispatchEvent(new CustomEvent('jorinde:produktfinder-complete', { bubbles: true, detail: { products: results.map(function (r) { return r.handle; }) } }));

        if (emailOn && results.length) {
          renderEmailGate(resultId, results, recommendedForEmail);
        } else {
          renderProductResults(results, false);
        }
      }

      var current = -1;
      function go(n) {
        current = n;
        if (n < 0) { root.classList.remove('jpf--wide'); stage.innerHTML = introHTML; var t = stage.querySelector('.jpf__title'); if (t) t.focus(); }
        else if (n >= qs.length) finish();
        else renderQuestion(n);
      }

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || !root.contains(btn)) return;
        if (btn.hasAttribute('data-jpf-start')) { sel = qs.map(function () { return []; }); go(0); }
        else if (btn.hasAttribute('data-jpf-next')) { go(current + 1); }
        else if (btn.hasAttribute('data-jpf-back')) { go(current - 1); }
        else if (btn.hasAttribute('data-jpf-restart')) { sel = qs.map(function () { return []; }); go(-1); }
      });
    }

    function initAll(ctx) {
      (ctx || document).querySelectorAll('[data-jpf]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
